import { API_BASE_URL } from '../../environments/environment';

/**
 * Resolves silhouette URLs to their correct format for display
 *
 * Handles three types of silhouette URLs:
 * 1. Default library images (/assets/silhouettes/*.png) - returned as-is
 * 2. Full S3 URLs (https://...amazonaws.com/...) - extracts filename and routes through backend proxy
 * 3. S3 path format (form_silhouettes/file.jpg) - extracts filename and routes through backend proxy
 *
 * @param silhouetteUrl - The silhouette URL to resolve
 * @returns The resolved URL ready for use in img src, or undefined if no URL provided
 */
export const getResolvedSilhouetteUrl = (silhouetteUrl: string | undefined): string | undefined => {
  if (!silhouetteUrl) {
    console.log('[SILHOUETTE] No URL provided');
    return undefined;
  }

  console.log('[SILHOUETTE] Resolving URL:', silhouetteUrl);

  // Default library images (local assets)
  if (silhouetteUrl.startsWith('/assets/')) {
    console.log('[SILHOUETTE] Type: Default library asset');
    return silhouetteUrl;
  }

  // Handle full S3 URLs (old format from database)
  if (silhouetteUrl.startsWith('http://') || silhouetteUrl.startsWith('https://')) {
    // Extract just the filename, let backend use default form_silhouettes/ folder
    const filename = silhouetteUrl.split('/').pop();
    const resolvedUrl = `${API_BASE_URL}/media/prompt-silhouette/${filename}`;
    console.log('[SILHOUETTE] Type: Full S3 URL → Backend proxy:', resolvedUrl);
    return resolvedUrl;
  }

  // S3 uploaded silhouettes (new format - path only)
  if (silhouetteUrl.includes('form_silhouettes/')) {
    const filename = silhouetteUrl.split('/').pop();
    const resolvedUrl = `${API_BASE_URL}/media/prompt-silhouette/${filename}`;
    console.log('[SILHOUETTE] Type: S3 path → Backend proxy:', resolvedUrl);
    return resolvedUrl;
  }

  // Backward compatibility - return as-is
  console.log('[SILHOUETTE] Type: Unknown format, returning as-is');
  return silhouetteUrl;
};
